<app-search-product-grid
    [option]="productSelectBoxOption"
    (appFormValue)="close($event)"
></app-search-product-grid>
